import { cn } from "@/lib/utils"

/**
 * Squelette de chargement.
 *
 * `motion-reduce:animate-none` est OBLIGATOIRE (DS §15.5, et §7.4 qui pose
 * `prefers-reduced-motion` comme non négociable) : sans lui, un utilisateur
 * sensible au mouvement voit clignoter la page entière à chaque chargement
 * d'onglet — une fiche en monte parfois huit d'un coup. Posé ici, sur le
 * primitif, plutôt qu'à chaque appel : c'est le seul endroit qui ne s'oublie pas.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse motion-reduce:animate-none rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
